document.addEventListener('DOMContentLoaded', () => {
  const sliders = document.querySelectorAll('.custom-home-banner__slider');

  sliders.forEach((slider) => {
    new Swiper(slider, {
		loop: true,
		speed: 600,
		slidesPerView: 1,
		spaceBetween: 0,
		autoplay: {
      delay: 5000,             
      disableOnInteraction: false,
      pauseOnMouseEnter: true 
    },
		pagination: {
			el: slider.querySelector('.swiper-pagination'),
			clickable: true,
		},
    });
  });
});